import { deepComputedFrom } from 'aurelia-deep-computed';
import { autoinject, computedFrom } from 'aurelia-framework';
import { ValidationRules } from 'aurelia-validation';
import { watch } from 'aurelia-watch-decorator';
import { WidgetController } from 'controls/as-widget-container';
import { BusinessDetails, initBusinessContact } from 'model/forms/travel-request';
import { KeywordsService } from 'services/keywords-service';
import { WidgetBase } from 'support/base_classes/widget-base';

@autoinject
export class BusinessDetailsWidget extends WidgetBase<BusinessDetails, WidgetController> {
  private previousBusinessContactsLength: number = null;

  constructor(private keywords: KeywordsService) {
    super();
  }

  changed() {
    this.previousBusinessContactsLength = this.model.businessContacts.length;
    this.bindValidation();
  }

  private bindValidation() {
    ValidationRules
      .ensureObject<BusinessDetails>().required()
      .ensure(model => model.travelType).displayName('Type of travel').required()
      .ensure(model => model.reasonForTravel).displayName('Reason for travel').required()
      .ensure(model => model.localArrangements).displayName('Local travel arrangements').required()
      .on(this.model);
  }

  @computedFrom('keywords.travelTypes', 'model.travelType')
  get travelTypes() {
    return this.keywords.ensureItem(this.keywords.travelTypes, this.model.travelType);
  }

  keywordsItemMatcher = this.keywords.itemsMatch;

  @deepComputedFrom('model.businessContacts')
  get shouldAutoCreateBusinessContact() {
    if (this.changing) return false;
    const previousLength = this.previousBusinessContactsLength;
    const currentLength = this.previousBusinessContactsLength = this.model.businessContacts.length;
    if (currentLength !== previousLength || currentLength === 0) return false;
    const lastContact = this.model.businessContacts[currentLength - 1];
    return lastContact.name != null || lastContact.phone != null || lastContact.mail != null;
  }

  @watch((x: BusinessDetailsWidget) => x.shouldAutoCreateBusinessContact)
  private shouldAutoCreateBusinessContactChanged(shouldAutoCreate: boolean) {
    if (shouldAutoCreate && !this.controller.disabled) this.addContact();
  }

  addContact() {
    const contact = initBusinessContact();
    this.model.businessContacts.push(contact);
  }
}
